<div class="home_page__wrapper">
  <div class="header__wrapper">
    <div class="img__wrapper">
      <img src="/assets/images/default-logo.svg" alt="" />
    </div>
  </div>
  <div class="main-content__wrapper mt-4">
    <div class="row justify-content-center">
      <div class="col-12 col-md-6 text-center">
        <h6 class="hp-title">Shared Intelligence.</h6>
        <p class="hp-description">
          The key to pursuing excellence is to embrace an organic, long-term
          learning process, and not to live in a shell of static, safe
          mediocrity. Usually, growth comes at the expense of previous comfort
          or safety. — Josh Waitzkin
        </p>
      </div>
    </div>
    <div class="row mt-4 justify-content-center">
      <div class="col-12 col-md-6 d-flex justify-content-center">
        <button class="btn btn-primary mr-3" routerLink="/register">
          Register
        </button>
        <button class="btn btn-outline-primary" (click)="goToLogin()">
          Login
        </button>
      </div>
    </div>
  </div>
  <div class="footer-wrapper">
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</div>
